import Cookies from 'js-cookie';
import { registerSW } from "virtual:pwa-register";

interface BeforeInstallPromptEvent extends Event {
    readonly platforms: Array<string>;
    readonly userChoice: Promise<{
        outcome: 'accepted' | 'dismissed',
        platform: string
    }>;
    prompt(): Promise<void>;
}

if ('serviceWorker' in navigator) {
    registerSW({immediate: true});

    const startPWA = () => {
        const wrapper = document.getElementById('pwa-install-wrapper');
        const notification = document.getElementById('pwa-notification');
        const iosPopup = document.getElementById('pwa-ios-popup');
        const btnInstall = document.getElementById('pwa-btn-install');
        const btnClose = document.querySelectorAll('.pwa-btn-close');

        if (!wrapper || !notification || !iosPopup || !btnInstall) {
            return;
        }

        if (
            Cookies.get('pwa_dismissed') == 'true' ||
            Cookies.get('pwa_is_installed') == 'true'
        ) {
            return;
        }

        const isStandalone = window.matchMedia('(display-mode: standalone)').matches || ('standalone' in window.navigator && (window.navigator as any).standalone === true);

        if (isStandalone) {
            Cookies.get('pwa_is_installed', 'true');
            return;
        }

        const ua = window.navigator.userAgent.toLowerCase();
        const isIOS = /iphone|ipad|ipod/.test(ua);

        let deferredPrompt: BeforeInstallPromptEvent | null = null;

        window.addEventListener('beforeinstallprompt', (e: Event) => {
            e.preventDefault();
            deferredPrompt = e as BeforeInstallPromptEvent;

            wrapper.classList.remove('hidden');
            notification.classList.remove('hidden');
        });

        if (isIOS) {
            wrapper.classList.remove('hidden');
            notification.classList.remove('hidden');
        }

        window.addEventListener('appinstalled', () => {
            Cookies.set('pwa_is_installed', 'true');
            wrapper.classList.add('hidden');
        });

        btnInstall.addEventListener('click', async () => {
            if (isIOS) {
                notification.classList.add('hidden');
                iosPopup.classList.remove('hidden');
                Cookies.set('pwa_dismissed', 'true');
            } else if (deferredPrompt) {
                await deferredPrompt.prompt();

                const {outcome} = await deferredPrompt.userChoice;

                if (outcome === 'accepted') {
                    wrapper.classList.add('hidden');
                }

                deferredPrompt = null;
            }
        });

        btnClose.forEach((btn) => {
            btn.addEventListener('click', () => {
                wrapper.classList.add('hidden');
                Cookies.set('pwa_dismissed', 'true', {expires: 30, path: '/'});
            });
        });
    }

    document.addEventListener('DOMContentLoaded', startPWA);

    document.addEventListener('livewire:navigated', startPWA);
}
